<template>
  <v-card tile elevation="1" class="z-index-2">
    <v-toolbar flat dense color="white">
      <!-- en el móvil no cabe junto a los botones: se queda solo el icono de documentos -->
      <v-toolbar-title v-if="!$vuetify.breakpoint.xs" class="font-weight-bold grey--text text--darken-2">
        Gestión de Activos
      </v-toolbar-title>

      <!-- Documentos generales del cliente -->
      <v-tooltip v-if="verDocumentos" bottom open-delay="300">
        <template #activator="{ on, attrs }">
          <v-badge
            :value="numDocumentos > 0"
            :content="numDocumentos"
            color="primary"
            overlap
            bordered
            offset-x="12"
            offset-y="12"
            :class="$vuetify.breakpoint.xs ? 'contador-documentos' : 'ml-3 contador-documentos'"
          >
            <v-btn
              icon
              small
              class="boton-documentos"
              aria-label="Documentos del cliente"
              v-bind="attrs"
              v-on="on"
              @click="$emit('open-docs-cliente')"
            >
              <v-icon small>mdi-folder-account-outline</v-icon>
            </v-btn>
          </v-badge>
        </template>
        <span>Documentos del cliente{{ numDocumentos ? ` (${numDocumentos})` : '' }}</span>
      </v-tooltip>

      <!-- Historial de cambios del cliente -->
      <v-tooltip v-if="verDocumentos" bottom open-delay="300">
        <template #activator="{ on, attrs }">
          <v-btn
            icon
            small
            class="ml-2 boton-documentos"
            aria-label="Historial de cambios"
            v-bind="attrs"
            v-on="on"
            @click="$emit('open-historial')"
          >
            <v-icon small>mdi-history</v-icon>
          </v-btn>
        </template>
        <span>Historial de cambios</span>
      </v-tooltip>

      <!-- Calidad de los datos del cliente (qué le falta por documentar) -->
      <v-tooltip v-if="verCalidad && !$vuetify.breakpoint.xs" bottom open-delay="300">
        <template #activator="{ on, attrs }">
          <v-btn icon small class="ml-2 boton-documentos" aria-label="Calidad de los datos" v-bind="attrs" v-on="on" @click="$emit('open-calidad')">
            <v-icon small>mdi-clipboard-check-outline</v-icon>
          </v-btn>
        </template>
        <span>Calidad de los datos</span>
      </v-tooltip>

      <!-- Ayuda -->
      <v-tooltip v-if="verAyuda" bottom open-delay="300">
        <template #activator="{ on, attrs }">
          <v-btn icon small class="ml-2 boton-documentos" aria-label="¿Cómo funciona?" v-bind="attrs" v-on="on" @click="$emit('open-ayuda')">
            <v-icon small>mdi-help-circle-outline</v-icon>
          </v-btn>
        </template>
        <span>¿Cómo funciona?</span>
      </v-tooltip>

      <v-spacer />

      <v-btn-toggle
        :value="listaModo"
        mandatory
        rounded
        class="custom-toggle"
        color="primary"
        @change="onToggleChange"
      >
        <v-btn value="armarios" small>
          <v-icon left small>mdi-locker-multiple</v-icon>
          Armarios
        </v-btn>

        <v-btn v-if="verPlanos" value="planos" small>
          <v-icon left small>mdi-map-marker-path</v-icon>
          Planos
        </v-btn>

        <v-btn icon value="armarios" color="primary" small aria-label="Leer QR" title="Leer QR" @click="$emit('open-scanner')">
          <v-icon small>mdi-qrcode-scan</v-icon>
        </v-btn>
      </v-btn-toggle>

      <v-spacer />

      <v-btn icon v-if="isMobile" aria-label="Abrir el panel lateral" @click="$emit('toggle-drawer')">
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </v-toolbar>
  </v-card>
</template>

<script>
export default {
  name: "ArmariosToolbar",
  props: {
    verCalidad: { type: Boolean, default: false },
    verAyuda: { type: Boolean, default: false },
    listaModo: { type: String, required: true },
    isMobile: { type: Boolean, default: false },
    verPlanos: {type: Boolean, default: true},
    verDocumentos: {type: Boolean, default: false},
    numDocumentos: {type: Number, default: 0},
  },
  methods: {
    onToggleChange(val) {
      // val será 'armarios' o 'planos'
      this.$emit("change-modo", val);
    },
  },
};
</script>

<style scoped>
/* Acceso a los documentos del cliente: icono sobre un círculo suave del color principal */
.boton-documentos {
  color: #117f9c !important;
  background-color: rgba(17, 127, 156, 0.08);
  transition: background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}
.boton-documentos:hover {
  background-color: rgba(17, 127, 156, 0.16);
  box-shadow: 0 2px 8px rgba(17, 127, 156, 0.25);
  transform: translateY(-1px);
}

.contador-documentos >>> .v-badge__badge {
  font-size: 0.65rem;
  font-weight: 700;
  height: 18px;
  min-width: 18px;
  padding: 3px 5px;
}

.custom-toggle {
  background-color: #f0f0f0 !important;
  border: 1px solid #e0e0e0;
}
.custom-toggle .v-btn {
  text-transform: none;
  font-weight: 500;
  letter-spacing: normal;
}
</style>